<template>
  <div class="invoice ">
    <small class="date">
      {{ doc.place }}, {{ doc.creation_date | formatDate }}
    </small>
    <small
      class="date"
      v-if="doc.details.sell_date && doc.details.sell_date !== doc.creation_date">
      Data sprzedaży: {{ doc.details.sell_date | formatDate }}
    </small>
    <br>
    <h1>Faktura {{ doc.name }}</h1>
    <br>
    <div class="people-data">
      <div class="view-section">
        <h2>Sprzedawca</h2>
        <span>{{ doc.from.name}}</span>
        <small>{{ doc.from.address }}</small>
        <small>{{doc.from.post_code }}, {{ doc.from.city }}</small>
        <small v-if="doc.from.vat">NIP: {{ doc.from.vat }}</small>
      </div>
      <div class="view-section">
        <h2>Nabywca</h2>
        <span>{{ doc.to.name}}</span>
        <small>{{ doc.to.address }}</small>
        <small>{{doc.to.post_code }}, {{ doc.to.city }}</small>
        <small v-if="doc.to.vat">NIP: {{ doc.to.vat }}</small>
      </div>
    </div>

    <div class="invoice-items">
      <div class="invoice-items__item invoice-items__item--header">
        <span>Nazwa</span>
        <span>Netto</span>
        <span>Ilość</span>
        <span>VAT</span>
        <span>Brutto</span>
      </div>
      <div class="invoice-items__item" v-for="item in doc.details.items" :key="item.name">
        <span>{{ item.name }}</span>
        <span>{{ item.netto | formatMoney(doc.details.currency) }}</span>
        <span>{{ item.qty | formatQuantity }}</span>
        <span>{{ item.tax }}</span>
        <span>{{ item.brutto * item.qty | formatMoney(doc.details.currency) }}</span>
      </div>
    </div>

    <div class="row">
      <div class="invoice-payment">
        <h2>Płatność</h2>
        <span>{{ doc.details.payment_details }}</span>
        <br>
        <h2>Otrzymano</h2>
        <span>{{ doc.details.received | formatMoney(doc.details.currency) }}</span>
        <span v-if="doc.details.description">
          <br>
          <h2>Uwagi</h2>
          <small>{{ doc.details.description}}</small>
        </span>
      </div>

      <div class="invoice-summary">
        <h2>Kwota netto</h2>
        <span>{{ doc.details.summary.netto | formatMoney(doc.details.currency) }}</span>
        <br><br>
        <h2>Kwota brutto</h2>
        <span class="invoice-summary__brutto">{{ doc.details.summary.brutto | formatMoney(doc.details.currency) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-invoice',
  computed: {
    doc() {
      return this.$store.state.docs.selectedDoc
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice {
  .date {
    width: 100%;
    display: block;
    text-align: right;
  }

  .people-data {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;

    @media screen and (min-width: #{$media-900}) {
      flex-direction: row;
    }
  }

  .view-section {
    font-size: 1.1em;
    margin-top: 12px;
    width: 100%;

    >* { display: block }
    span { font-weight: 500; }
    b { font-weight: 500; }
    h2 {
      text-align: left;
    }
  }

  .invoice-items {
    width: 100%;
    margin-top: 32px;

    &__item {
      display: grid;
      grid-template-columns: 1fr 0.3fr 0.3fr 0.3fr 0.3fr;

      >* {
        padding: 8px 4px;
      }

      &--header {
        font-weight: 300;
        font-size: 0.8em;
        color: #666;
        border-bottom: dashed 1px #666;

        >* {
          padding: 4px;
        }
      }
    }
  }

  .row {
    width: 100%;
    display: flex;
    justify-content: space-between;
      flex-direction: column-reverse;

    @media screen and (min-width: #{$media-900}) {
      flex-direction: row;
    }
  }

  .invoice-payment {
    text-align: left;
    margin-top: 32px;
    width: 100%;

    h2 {
      text-align: left;
      margin-top: 4px;
    }
  }

  .invoice-summary {
    text-align: right;
    margin-top: 32px;
    width: 100%;

    h2 {
      text-align: right;
    }

    &__brutto {
      font-size: 2em !important;
    }

    span {
      font-size: 1.3em;
    }
  }

  h2 {
    margin: 0;
    font-size: 0.6em;
    color: #333;
    font-weight: 400;
  }

  .flex {
    display: flex;

    .view-section {
      width: 50%;
    }
  }
}
</style>
